export interface Pagination {
  totalItems: number;
  totalPages: number;
}

export interface PaginationForm {
  pageNumber: number;
  pageSize: number;
}
